import { jsx as _jsx } from "react/jsx-runtime";
import { useSeparator } from '@react-aria/separator';
const MenuDivider = () => {
    const { separatorProps } = useSeparator({});
    return _jsx("li", { ...separatorProps, className: "bg-light-gray mx-4 block h-[1px] rounded-full" });
};
/**
 * A menu divider is a separator between actions within
 * a menu.
 */
export const ReactAriaMenuDivider = () => {
    return null;
};
ReactAriaMenuDivider.getCollectionNode = function* getCollectionNode(props) {
    yield {
        hasChildNodes: false,
        props,
        type: 'separator',
    };
};
export default MenuDivider;
//# sourceMappingURL=MenuDivider.js.map